import {
  getStackedBarChartData,
  getStackedBarChartOptions,
} from './getStackedBarChartOptions';
import { Chart } from '../categoricalCharts/EChart';
import { StackedBarChartWidgetProps } from './types';
import { Maybe } from '@ardoq/api-types';

export const StackedBarChartWidget = ({
  data,
  numberSlices,
  colors,
  dashboardContainerRef,
  width,
  userLocale,
  i18nLocale,
}: StackedBarChartWidgetProps & {
  dashboardContainerRef: Maybe<HTMLDivElement>;
}) => (
  <Chart
    chartOptions={getStackedBarChartOptions(
      getStackedBarChartData(data, numberSlices, userLocale),
      colors,
      width,
      dashboardContainerRef,
      userLocale,
      i18nLocale
    )}
  />
);
